import React, { useEffect, useState } from "react";
import Card from "../../shared/widgets/Card/Card";
import CardLayout from "../../shared/pageLayouts/cardLayout/CardLayout";
import { APIService } from "../../../services/APIService";
import { ServiceURI } from "../../../services/ServiceURI";
import { ITeam } from "../../../models/Team.model";
import AgentRuntime from "./AgentRuntime/AgentRuntime";
import { FaPlay, FaUsers } from "react-icons/fa";
import { TeamsCreateForm } from "./teamsCreateForm";
import CreateLayout from "../../shared/pageLayouts/createLayout/CreateLayout";
import { IForm } from "../../shared/widgets/Form/models/Form.model";
import { Button } from "primereact/button";
import SharedForm from "../../shared/widgets/Form/Form";
import { IAgent } from "../../../models/Agent.model";
import DragDnd from "../../shared/widgets/DragDnd/DragDnd";
import { ReactFlowProvider } from "@xyflow/react";
import "./Teams.scss";
import { MdEdit } from "react-icons/md";
import { Utils } from "../../../utils/Utils";

export default function Teams() {
  const [agents, setAgents] = useState<IAgent[]>([]);
  const [teams, setTeams] = useState<ITeam[]>([]);
  const [showRunTime, setShowRunTime] = useState(false);
  const [isCreateTab, setIsCreateTab] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [form, setForm] = useState(TeamsCreateForm);
  const [selectedTeam, setSelectedTeam] = useState<{
    name: string;
    agents: any[];
  }>({ name: "", agents: [] });
  const [newTeam, setNewTeam] = useState<ITeam>({
    id: "",
    logo: "",
    name: "",
    description: "",
    agents: [],
  });

  const fetchTeams = async () => {
    const res = await APIService.getCall(ServiceURI.TEAMS.FATCH_TEAMS);
    if (res) {
      setTeams(res);
    }
  };

  const fetchAgents = async () => {
    const res = await APIService.getCall(ServiceURI.AGENTS.FATCH_AGENTS);
    if (res) {
      setAgents(res);
    }
  };

  const handleEditCardClick = (cardTeam: any) => {
    const updateForm = TeamsCreateForm.map((item: IForm) => {
      return { ...item, value: cardTeam[item.field] };
    });
    setIsEditMode(true);
    setIsCreateTab(true);
    setSelectedTeam(cardTeam);
    setForm(updateForm);
  };

  const handleCardClick = (cardTeam: ITeam) => {
    setSelectedTeam(cardTeam);
    setShowRunTime(true);
  };

  useEffect(() => {
    fetchAgents();
    fetchTeams();
  }, []);

  const handleCreateTeam = () => {
    const existingList: ITeam[] = Utils.deepClone(teams);
    if (existingList.some((item) => item.name === newTeam.name)) {
      setTeams((prev) =>
        prev.map((item) => {
          if (item.name === newTeam.name) {
            return { ...item, ...newTeam };
          }
          return item;
        })
      );
    } else {
      setTeams((prev) =>
        prev.concat([{ ...newTeam, id: prev.length.toString() }])
      );
    }
    setIsCreateTab(false);
  };

  const CardFooter = ({ team }: { team: ITeam }) => {
    return (
      <div className="team-card-footer">
        <Button
          className="primary"
          onClick={() => handleCardClick(team)}
          raised
        >
          <FaPlay />
        </Button>
        <Button
          className="default"
          raised
          onClick={() => handleEditCardClick(team)}
        >
          <MdEdit />
        </Button>
      </div>
    );
  };

  return (
    <ReactFlowProvider>
      <div className="teams-layout">
        {isCreateTab ? (
          <CreateLayout
            title="Team"
            contentChildren={CreateFormContent(
              setIsCreateTab,
              form,
              setForm,
              agents,
              setNewTeam,
              handleCreateTeam,
              selectedTeam.agents,
              isEditMode
            )}
            goBack={() => setIsCreateTab(false)}
          />
        ) : showRunTime ? (
          <AgentRuntime
            selectedTeam={selectedTeam}
            setShowRunTime={setShowRunTime}
          />
        ) : (
          <CardLayout
            title="Teams"
            addButtonClicked={() => {
              setIsEditMode(false);
              setSelectedTeam({ name: "", agents: [] });
              setForm(TeamsCreateForm);
              setIsCreateTab(true);
            }}
          >
            {teams.map((item, i) => {
              return (
                <Card
                  key={i}
                  icon={<FaUsers />}
                  item={{
                    title: item.name,
                    content: item.description,
                    logo: item.logo,
                  }}
                  isCardClickDisabled={true}
                  cardFooter={<CardFooter team={item} />}
                  handleCardClick={() => handleCardClick(item)}
                />
              );
            })}
          </CardLayout>
        )}
      </div>
    </ReactFlowProvider>
  );
}

const CreateFormContent = (
  setIsCreateTab: any,
  form: IForm[],
  setForm: any,
  agents: IAgent[],
  setNewTeam: any,
  handleCreateTeam: any,
  targetAgents: IAgent[],
  isEditMode: boolean
) => {
  const handleDragChange = (selectedAgents: IAgent[]) => {
    setNewTeam((prev: ITeam) => Object({ ...prev, agents: selectedAgents }));
  };

  const handleFormChange = (formData: IForm[]) => {
    setForm(formData);
    const data: { [key: string]: string } = {
      logo: "",
    };
    formData.forEach((item) => {
      data[item.field] = item.value;
    });
    setNewTeam((prev: ITeam) => Object({ ...prev, ...data }));
  };

  const formRender = (
    <div className="create-form-content">
      <SharedForm
        form={form}
        setForm={(formData: IForm[]) => handleFormChange(formData)}
      />
      <DragDnd
        dragSection={agents}
        targetSection={targetAgents}
        handleDragChange={handleDragChange}
      />
    </div>
  );

  const footerRender = (
    <div className="create-form-footer">
      <Button
        label="Cancel"
        onClick={() => setIsCreateTab(false)}
        severity="secondary"
        text
      />
      <Button
        label={`${isEditMode ? "Update" : "Create"} Team`}
        onClick={() => handleCreateTeam()}
        raised
        className="primary"
      />
    </div>
  );

  return (
    <>
      {formRender}
      {footerRender}
    </>
  );
};
